import { DirectionalHint, IButtonProps, TeachingBubble } from "@fluentui/react";
import { LightbulbIcon } from "@fluentui/react-icons-mdl2";
import React, { useMemo } from "react";
import { useState } from "react";
import * as L from '@/screen/FundDetail/Styles/FundDetailStyles';

export type TTextTip = {
    title: string;
    description: string;
}

type TCustomTeachingBubbleProps = {
    images: string[];
    texts: TTextTip[];
    targetIdentifier: string;
    showTooltip: () => void;
}

type TDataTip = {
    image: string;
    text: TTextTip;
    numberOfPage: number;
}

const CustomTeachingBubble: React.FC<TCustomTeachingBubbleProps> = ({ images, texts, targetIdentifier, showTooltip }) => {

    let dataTipList: TDataTip[] = [];

    for (let i = 0; i < texts.length; i++) {
        dataTipList.push({
            image: images[i],
            text: texts[i],
            numberOfPage: i
        })
    }

    const lenghOfToolTip = texts.length
    
    const [tooltipRatioPage, setTooltipRatioPage] = useState<number>(0);

    const stepTooltipFirstButton: IButtonProps = useMemo(() =>
    (
        {
            children: 'Siguiente',
            disabled: tooltipRatioPage === lenghOfToolTip - 1,
            onClick: () => setTooltipRatioPage(prevState => prevState + 1),
            className: 'mini-primary-button'
        }),
        [tooltipRatioPage]
    );
    const stepTooltipSecondButton: IButtonProps = useMemo(() =>
    (
        {
            children: 'Anterior',
            disabled: tooltipRatioPage === 0,
            onClick: () => setTooltipRatioPage(prevState => prevState - 1),
            className: 'mini-primary-button'
        }),
        [tooltipRatioPage]
    );

    return (
            <TeachingBubble target={`#${targetIdentifier}`}
                primaryButtonProps={stepTooltipFirstButton}
                secondaryButtonProps={stepTooltipSecondButton}
                footerContent={`${tooltipRatioPage + 1} de ${lenghOfToolTip}`}
                onDismiss={showTooltip}
                calloutProps={
                    {
                        backgroundColor: 'white !important',
                        style: { color: 'red' },
                        directionalHint: DirectionalHint.rightTopEdge
                    }}
                hasCloseButton={true}
                closeButtonAriaLabel="Cerrar"
                styles={
                    {
                        bodyContent: { '.ms-Icon': { color: '#555 !important' } },
                        body:
                        {
                            background: 'white',
                            marginRight: '0',
                            marginBottom: '0 !important',
                            '.TipStep': { transition: 'all 0.5s ease-in-out 0s', opacity: '1' },
                            '.hidden': { opacity: '0', display: 'inline-block !important', height: '0', width: '0', overflow: 'hidden' }
                        },
                        subText: { color: '#555 !important', 'p': { margin: '5px 0' } },
                        footer:
                        {
                            color: '#555 !important',
                            '.ms-Button:not(:first-child)': { marginLeft: '0 !important' }
                        }
                    }}
            >
                <div className='header'>
                    <LightbulbIcon style={{ color: 'gold', width: '20px', height: '20px' }} />
                    <h3 style={{ display: 'inline', verticalAlign: 'middle', marginLeft: '5px', cursor: 'default' }}>Tips</h3>
                </div>
                {dataTipList.map((dataTip: TDataTip) => (
                    <div className={`TipStep ${tooltipRatioPage === dataTip.numberOfPage ? '' : 'hidden'}`}>
                        <img src={dataTip.image} alt={dataTip.image} style={{ margin: '5px 0', width: '100%' }} />
                        <h4>
                            {dataTip.text.title}
                        </h4>
                        <L.TipParagraph>
                            {dataTip.text.description.split("\n").map((line, index) => (
                                <React.Fragment key={index}>
                                    {line}
                                    <br />
                                </React.Fragment>
                            ))}
                        </L.TipParagraph>
                    </div>
                ))}
        </TeachingBubble>
    )
};

export default CustomTeachingBubble;